export default "__VITE_ASSET__CsWs48yK__"